"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Popover = void 0;
var dialog_1 = require("@react-aria/dialog");
var focus_1 = require("@react-aria/focus");
var overlays_1 = require("@react-aria/overlays");
var utils_1 = require("@react-aria/utils");
var react_1 = __importStar(require("react"));
var Popover_styled_1 = require("./Popover.styled");
// AriaDialogProps are not exported by @react-aria;
function Popover(props) {
    var ref = (0, react_1.createRef)();
    var _a = props.popoverRef, popoverRef = _a === void 0 ? ref : _a, isOpen = props.isOpen, onClose = props.onClose, children = props.children, otherProps = __rest(props, ["popoverRef", "isOpen", "onClose", "children"]);
    var overlayProps = (0, overlays_1.useOverlay)({
        isOpen: isOpen,
        onClose: onClose,
        shouldCloseOnBlur: true,
        isDismissable: true,
    }, popoverRef).overlayProps;
    var modalProps = (0, overlays_1.useModal)().modalProps;
    var dialogProps = (0, dialog_1.useDialog)(otherProps, popoverRef).dialogProps;
    // Add a hidden <DismissButton> component at the end of the popover
    // to allow screen reader users to dismiss the popup easily.
    return (react_1.default.createElement(focus_1.FocusScope, { contain: true, restoreFocus: true },
        react_1.default.createElement(Popover_styled_1.StyledPopover, __assign({}, (0, utils_1.mergeProps)(overlayProps, modalProps, dialogProps), { ref: popoverRef }),
            children,
            react_1.default.createElement(overlays_1.DismissButton, { onDismiss: onClose }))));
}
exports.Popover = Popover;
